import { render, staticRenderFns } from "./FeedVip.vue?vue&type=template&id=15fde06e&"
import script from "./FeedVip.vue?vue&type=script&lang=ts&"
export * from "./FeedVip.vue?vue&type=script&lang=ts&"
import style0 from "./FeedVip.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports